// Deleted records (spec C7.5, C15a; Renewals board): two tabs, Requests (approve or reject) and
// Deleted (restore within 30 days). Deleting records is not built yet, so both lists are empty and
// say so; the tab lives in the address like the lists' tabs.
import { useSearchParams } from 'react-router';
import { EmptyState } from '../shell/EmptyState';
import { PageHeader } from '../shell/PageHeader';

type Tab = 'requests' | 'deleted';

const tabs: { key: Tab; label: string; empty: string }[] = [
  { key: 'requests', label: 'Requests', empty: 'No delete requests.' },
  { key: 'deleted', label: 'Deleted', empty: 'No records deleted in the last 30 days.' },
];

export function DeletedRecordsPage() {
  const [params, setParams] = useSearchParams();
  const tab: Tab = params.get('tab') === 'deleted' ? 'deleted' : 'requests';
  const current = tabs.find((t) => t.key === tab)!;
  return (
    <>
      <PageHeader
        title="Deleted records"
        subtitle="Delete requests to approve or reject, and records deleted in the last 30 days"
      />
      <div className="col g8">
        <div className="ltb">
          <div className="seg" role="group" aria-label="Deleted records">
            {tabs.map((t) => (
              <button
                key={t.key}
                type="button"
                className={tab === t.key ? 'seg-b on' : 'seg-b'}
                aria-pressed={tab === t.key}
                onClick={() =>
                  setParams(t.key === 'requests' ? {} : { tab: t.key }, { replace: true })
                }
              >
                {t.label}
                <span className="n">0</span>
              </button>
            ))}
          </div>
        </div>
        <EmptyState text={current.empty} />
        {tab === 'deleted' && (
          <p className="m0 t12 muted">
            A deleted record stays here for 30 days and can be restored, then it is removed with its
            files.
          </p>
        )}
      </div>
    </>
  );
}
